import React from 'react';
import { Text } from 'grommet';

// Helpers and utilities
import { TypographySettings } from '@theme/globals/typography';

// Types
import type { SHDTextProps } from './SHDText.d';

const SHDText: React.FC<SHDTextProps> = ({
  children,
  className = 'text',
  color = 'gray-900',
  style = 'body',
  textAlign,
  dataTestId = '',
}) => {
  const styleSettings = {
    fontFamily: TypographySettings[style].family,
    lineHeight: TypographySettings[style].height,
    textTransform: style === 'subhead-all-caps' ? 'uppercase' : 'none',
    letterSpacing: style === 'subhead-all-caps' ? '0.03em' : 'inherit',
  };

  return (
    <Text
      data-testid={dataTestId}
      data-font-style={style}
      className={className}
      color={color}
      size={TypographySettings[style].size}
      style={styleSettings as React.CSSProperties}
      weight={TypographySettings[style].weight}
      textAlign={textAlign}
    >
      {children}
    </Text>
  );
};

export default SHDText;
